import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const ORDER_FILES_ENDPOINTS = {
  V1: createEndpoints('v1', {
    ADMIN_ORDER_DOCUMENTATIONS: (orderID: number) => `/admin-order-documentations/${orderID}/`,
  }),
} as const;
